import React, { createContext, useContext, useState } from 'react';
import Toaster from '../components/Toaster';

const ToasterContext = createContext();

export const useToaster = () => {
  const context = useContext(ToasterContext);
  if (!context) {
    throw new Error('useToaster must be used within a ToasterProvider');
  }
  return context;
};

export const ToasterProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showSuccess = (title, message) => {
    const id = Date.now();
    const toast = {
      id,
      type: 'success',
      title,
      message,
    };
    setToasts(prev => [...prev, toast]);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      removeToast(id);
    }, 5000);
  };

  const showError = (title, message) => {
    const id = Date.now();
    const toast = {
      id,
      type: 'error',
      title,
      message,
    };
    setToasts(prev => [...prev, toast]);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      removeToast(id);
    }, 5000);
  };

  const showWarning = (title, message) => {
    const id = Date.now();
    const toast = {
      id,
      type: 'warning',
      title,
      message,
    };
    setToasts(prev => [...prev, toast]);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      removeToast(id);
    }, 5000);
  };

  const showInfo = (title, message) => {
    const id = Date.now();
    const toast = {
      id,
      type: 'info',
      title,
      message,
    };
    setToasts(prev => [...prev, toast]);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      removeToast(id);
    }, 5000);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const value = {
    toasts,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    removeToast,
  };

  return (
    <ToasterContext.Provider value={value}>
      {children}
      <Toaster toasts={toasts} removeToast={removeToast} />
    </ToasterContext.Provider>
  );
}; 